module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0029.c92a5624.jpg";